/* eslint-disable */

import React from "react";
import { Outlet } from "react-router-dom";

import Spacer from "../../../ui-components/spacer/spacer";
import RaindropCopyrightDeclaration from "../../../ui-components/raindrop-copyright-declaration/raindrop-copyright-declaration";

const CirrusBaseAnonymous = ({ isDemo, setUserCurrent }) => {
  const colorBackground =
    "bg-color-dark-background-primary bg-color-background-primary";
  const border = "border border-color-dark-border-primary";

  return (
    <div
      className={
        "flex flex-col w-full h-full py-6 gap-0 justify-around items-center overflow-x-visible dark bg-color-dark-background-primary"
      }
    >
      <div className="flex w-full h-full absolute items-end">
        {/* <BackgroundBlurs className={""} /> */}
      </div>

      <div
        className={`flex flex-col w-full  max-w-4xl gap-16 relative p-24 rounded-lg z-20   ${colorBackground}`}
      >
        <Outlet />
      </div>
      <div className="absolute flex flex-col h-full pb-12 text-color-dark-text-primary opacity-30">
        <Spacer />
        <RaindropCopyrightDeclaration />
      </div>
    </div>
  );
};

export default CirrusBaseAnonymous;
